export default __webpack_public_path__ + "static/media/model-3.5a5c0999.png";